module.exports = __webpack_public_path__ + "img/PropietarioDatos.ec83789e.svg";